/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Settings_Category_Makedefault1Inputs */

const en_cases_settings_category_makedefault1 = /** @type {(inputs: Cases_Settings_Category_Makedefault1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make default`)
};

/**
* | output |
* | --- |
* | "Make default" |
*
* @param {Cases_Settings_Category_Makedefault1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cases_settings_category_makedefault1 = /** @type {((inputs?: Cases_Settings_Category_Makedefault1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Settings_Category_Makedefault1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cases_settings_category_makedefault1(inputs)
});
export { cases_settings_category_makedefault1 as "cases_settings_category_makeDefault" }